import { EnvVar } from "../../../../schema/types/env";
import { EnvVarInput } from "../../../../schema/types/workload/input";
import { v4 as uuidv4 } from "uuid";

export function inputToEnv(inputs: EnvVarInput[]): EnvVar[] {
  let collection: EnvVar[] = [];
  for (const ev of inputs.toReversed()) {
    if (!ev.name || collection.some((ev2) => ev2.name === ev.name)) {
      continue;
    }
    let value = ``;
    if (ev.prefix === "cpln://secret/") {
      const suffix = ev.suffix ? `.${ev.suffix}` : "";
      value += `${ev.prefix}${ev.cplnSecret.value}${suffix}`;
    } else if (ev.prefix === "k8s://secret/") {
      value += `${ev.prefix}${ev.k8sSecret}`;
    } else if (ev.prefix === "cpln://reference/") {
      value += `${ev.prefix}${ev.reference}`;
    } else {
      value += `${ev.text}`;
    }
    collection.push({ name: ev.name, value: value });
  }
  return collection.toReversed();
}

export function envToInput(envVar: EnvVar[]): EnvVarInput[] {
  let inputs: EnvVarInput[] = [];

  const cplnSecretPrefix = `cpln://secret/`;
  const k8sSecretPrefix = `k8s://secret/`;
  const referencePrefix = `cpln://reference/`;

  for (const ev of envVar.toReversed()) {
    if (!ev.name || inputs.some((ev2) => ev2.name === ev.name)) {
      continue;
    }

    let value = ev.value || "";
    let prefix = "";
    let suffix = "";
    let text = "";
    let cplnSecret = "";
    let k8sSecret = "";
    let reference = "";

    if (value.startsWith(cplnSecretPrefix)) {
      prefix = cplnSecretPrefix;
      cplnSecret = value.split(cplnSecretPrefix)[1];
      if (cplnSecret.includes(".")) {
        const dotIndex = cplnSecret.indexOf(".");
        suffix = cplnSecret.slice(dotIndex + 1);
        cplnSecret = cplnSecret.slice(0, dotIndex);
      }
    } else if (value.startsWith(k8sSecretPrefix)) {
      prefix = k8sSecretPrefix;
      k8sSecret = value.split(k8sSecretPrefix)[1];
    } else if (value.startsWith(referencePrefix)) {
      prefix = referencePrefix;
      reference = value.split(referencePrefix)[1];
    } else {
      text = value;
    }
    const envVar: EnvVarInput = {
      id: uuidv4(),
      name: ev.name,
      prefix: prefix,
      suffix: suffix,
      text: text,
      cplnSecret: {
        value: cplnSecret,
        link: `//secret/${cplnSecret}`, // TODO does it need to be an absolute link always?
      },
      k8sSecret: k8sSecret,
      reference: reference,
    };
    inputs.push(envVar);
  }
  return inputs.toReversed();
}

export function envToText(envVar: EnvVar[]): string {
  const inputs = envToInput(envVar);
  return envInputToText(inputs);
}

export function envInputToText(inputs: EnvVarInput[]): string {
  let text = ``;
  for (const envVar of inputs) {
    if (!envVar?.name) {
      continue;
    }
    const value =
      envVar.prefix === "cpln://secret/"
        ? envVar.cplnSecret.value
        : envVar.prefix === "k8s://secret/"
        ? envVar.k8sSecret
        : envVar.prefix === `cpln://reference/`
        ? envVar.reference
        : envVar.text;
    const suffix = envVar.prefix === "cpln://secret/" && envVar.suffix ? `.${envVar.suffix}` : "";
    text += `${envVar.name}=${envVar.prefix || ""}${value}${suffix}\n`;
  }
  return text;
}
